// Получить название категории для определенного языка
export function getCategoryTitle(category, language) {
    if (!category) return ''

    // Фоллбэк заголовки если данные из Sanity пустые
    const fallbackTitles = {
        'tours': { ru: 'Туры', en: 'Tours' },
        'tours-and-attractions': { ru: 'Туры', en: 'Tours' },
        'transport': { ru: 'Транспорт', en: 'Transport' },
        'stay': { ru: 'Проживание', en: 'Accommodation' },
        'vpn': { ru: 'VPN', en: 'VPN' },
        'esim': { ru: 'eSIM', en: 'eSIM' },
        'insurance': { ru: 'Страховки', en: 'Insurance' },
        'tips': { ru: 'Советы', en: 'Tips' }
    }

    const title = language === 'ru' ? category.titleRu : category.titleEn

    // Если заголовок пустой, используем фоллбэк
    if (!title && category.slug?.current) {
        const slug = normalizeSlug(category.slug.current)
        return fallbackTitles[slug] ? fallbackTitles[slug][language] : slug
    }

    return title || ''
}

// Получить описание категории для определенного языка
export function getCategoryDescription(category, language) {
    if (!category) return ''

    const description = language === 'ru' ? category.descriptionRu : category.descriptionEn

    // НЕ показываем описания, возвращаем только если есть в Sanity
    return description || ''
}

// Маппинг старых slug'ов на новые (для обратной совместимости)
export const legacySlugMap = {
    'tours': 'tours-and-attractions',
    'tours-and-attractions': 'tours-and-attractions',
    'ru-tours': 'tours-and-attractions',
    'en-tours': 'tours-and-attractions',
    'ru-tours-and-attractions': 'tours-and-attractions',
    'en-tours-and-attractions': 'tours-and-attractions',
    'ru-transport': 'transport',
    'en-transport': 'transport',
    'ru-stay': 'stay',
    'en-stay': 'stay',
    'en-accomodation': 'stay',
    'ru-vpn': 'vpn',
    'en-vpn': 'vpn',
    'ru-esim': 'esim',
    'en-esim': 'esim',
    'ru-tips': 'tips',
    'en-tips': 'tips'
}

// Очистить slug от языкового префикса (если есть)
export function normalizeSlug(slug) {
    return legacySlugMap[slug] || slug
}

// Градиенты для категорий (по slug без языкового префикса)
export const categoryGradients = {
    'tours': 'from-orange-600/80 to-orange-400/80',
    'tours-and-attractions': 'from-orange-600/80 to-orange-400/80',
    'transport': 'from-amber-600/80 to-yellow-500/80',
    'stay': 'from-green-600/80 to-green-400/80',
    'vpn': 'from-blue-600/80 to-blue-400/80',
    'esim': 'from-purple-600/80 to-purple-400/80',
    'insurance': 'from-emerald-600/80 to-emerald-400/80',
    'tips': 'from-pink-500/80 to-rose-600/80'
}

// Иконки для категорий
export const categoryIcons = {
    'tours': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
    ),
    'tours-and-attractions': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
    ),
    'transport': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
        </svg>
    ),
    'stay': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
    ),
    'vpn': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
    ),
    'esim': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
    ),
    'tips': (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
    )
} 